module.exports = __webpack_public_path__ + "img/202411_01.08137739.jpg";